export type FeatureName = typeof FeatureNameDescriptions[number]['key'];

export const FeatureNameDescriptions: {
  description: string;
  key: string;
}[] = [
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'app b2c",
    key: 'b2c-allow-document-management',
  },
  {
    description:
      "Permet d'avoir les filtres des horaires dans la page de recherche de l'app b2c",
    key: 'b2c-allow-period-filters',
  },
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'email customer",
    key: 'b2c-allow-document-management-email',
  },
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'app b2b insurer",
    key: 'b2b-allow-document-management-insurer',
  },
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'email insurer",
    key: 'b2b-allow-document-management-insurer-email',
  },
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'app b2b fitter",
    key: 'b2b-allow-document-management-fitter',
  },
  {
    description:
      "Permet de proposer le chargement de photos de sinistres dans l'email fitter",
    key: 'b2b-allow-document-management-fitter-email',
  },
  {
    description:
      "Permet à l'agent B2B d'envoyer à l'assuré un mail d'accès au dossier afin qu'il continue le parcours en B2C de son côté",
    key: 'send-customer-access-email',
  },
  {
    description:
      "Active l'envoi des mails respectifs à l'assureur (post-réservation)",
    key: 'send-insurer-link-after-book',
  },
  {
    description:
      "Active l'envoi des mails respectifs aux superviseurs de l'assureur après demande de RDV",
    key: 'send-supervisors-link-after-request',
  },
  {
    description:
      "Active l'envoi des mails respectifs à l'assuré (post-réservation)",
    key: 'send-customer-link-after-book-or-cancel',
  },
  {
    description: "Active l'envoi du SMS de confirmation client après un book",
    key: 'send-book-sms-notifications',
  },
  {
    description:
      "Active l'envoi des mails respectifs au fitter (post-réservation)",
    key: 'send-fitter-link-after-book',
  },
  {
    description:
      "Permet d'accéder à la page des statistiques (menu statistique), sous réserve que l'utilisateur ait également le droit d'y accéder",
    key: 'access-dashboards',
  },
  {
    description:
      "Permet d'activer l'authentification gestionnaire par lien mail",
    key: 'b2b-auth-method-cta-token',
  },
  {
    description:
      "Force l'usage d'au moins un caractère spécial lors de la création du mot de passe",
    key: 'password-require-special-char',
  },
  {
    description:
      "Permet d'activer l'authentification gestionnaire par mot de passe",
    key: 'b2b-auth-method-password',
  },
  {
    description:
      "Permet d'activer l'authentification gestionnaire par SSO en utilisant la technologie SAML",
    key: 'b2b-auth-method-saml',
  },
  {
    description:
      "Permet d'activer l'authentification gestionnaire par SSO en utilisant la technologie OIDC",
    key: 'b2b-auth-method-oidc',
  },
  {
    description:
      "Permet d'activer la redirection automatique vers le login SSO (OIDC ou SAML) pour les B2B qui rentrent sur les dossiers avec un cta",
    key: 'b2b-auth-autoredirect-sso',
  },
  {
    description:
      "Permet d'activer l'authentification directe via le portail Okta en B2B",
    key: 'b2b-auth-okta-redirect',
  },
  {
    description:
      "Permet d'activer l'authentification directe via le portail Okta dans l'agenda",
    key: 'agenda-auth-okta-redirect',
  },
  {
    description:
      "Permet d'activer l'authentification fitter par SSO en utilisant la technologie OIDC",
    key: 'fitter-auth-method-oidc',
  },
  {
    description:
      "Permet d'envoyer un rappel 24h avant un RDV (actuellement service français d'envoi de SMS !!!)",
    key: 'send-appointment-reminder',
  },
  {
    description: "Affiche 'réparation' ou 'remplacement'",
    key: 'b2b-display-sinister-operation-type-info',
  },
  {
    description:
      "Affiche 'address not found' dans le sélectionneur d'adresse sur le parcours B2B",
    key: 'display-address-not-found-suggestion',
  },
  {
    description: 'Affiche un disclaimer sur le multi-dommage',
    key: 'b2b-display-sinister-multi-damage-info',
  },
  {
    description:
      "Permet de faire entrer ou non l'utilisateur sur une étape de pré-declaration (identification)",
    key: 'b2c-access-pre-declaration',
  },
  {
    description:
      "Permet de rentrer dans le parcours en mode 'Open Arrival' avec une saisie minimaliste d'info (plaque, date de sinistre)",
    key: 'b2c-access-open-arrival',
  },
  {
    description:
      'Permet de charger les fichiers de statistiques de réparation/remplacement afin de calculer le taux de réparation',
    key: 'b2b-repair-ratio-statistics',
  },
  {
    description: 'Propose la saisie du numéro de contrat assuré en B2B',
    key: 'b2b-field-required-contract-number',
  },
  {
    description:
      'Permet de saisir un numéro de plaque sur la première page de déclaration en B2C',
    key: 'b2c-can-declare-licenseplate-customer-informations-page',
  },
  {
    description: "Propose l'affichage du numéro de contrat assuré",
    key: 'b2b-field-display-contract-number',
  },
  {
    description: "Couverture BG obligatoire pour l'entrée de parcours",
    key: 'b2c-declaration-start-insurance-required',
  },
  {
    description: "Oblige l'utilisateur à accepter les conditions RGPD (en B2B)",
    key: 'b2b-field-required-gpdr',
  },
  {
    description: "Oblige l'utilisateur à accepter les conditions RGPD (en B2C)",
    key: 'b2c-field-required-gpdr',
  },
  {
    description:
      "Affiche les informations relatives à la plaque d'immatriculation pour le RGPD (en B2C)",
    key: 'b2c-display-license-plate-gpdr-info',
  },
  {
    description:
      "Oblige l'utilisateur à accepter les conditions d'utilisation des data marketing (en B2B)",
    key: 'b2b-field-display-marketing-data',
  },
  {
    description:
      "Oblige l'utilisateur à accepter les conditions d'utilisation des data marketing (en B2C)",
    key: 'b2c-field-display-marketing-data',
  },
  {
    description: "Affiche des radio bouton pour le choix de l'assurance",
    key: 'b2b-field-radio-selection-insurer-company',
  },
  {
    description:
      "Modifie le comportement 'getPlacesFromPostalCode' ou 'getPlacesFromAddress'",
    key: 'display-autocomplete-for-postal-code',
  },
  {
    description:
      "Permet l'activation de l'accès au service d'info des pièces autover",
    key: 'b2b-access-car-parts',
  },
  {
    description:
      "Permet de lancer une boite de sélection de la raison de l'appel : 'launchCallReasonDialog'",
    key: 'can-declare-call-reason',
  },
  {
    description: 'Affichage de la facilité no-show pour le fitter',
    key: 'can-declare-no-show',
  },
  { description: "Affichage du coût d'intervention", key: 'b2b-display-costs' },
  {
    description:
      "Permet d'afficher les boutons de modification de rdv (si le fitter le propose aussi)",
    key: 'can-do-appointment-modification-insurer',
  },
  {
    description:
      "Permet d'afficher les boutons d'annulation de rdv (si le fitter le propose aussi)",
    key: 'can-do-appointment-cancel-insurer',
  },
  {
    description:
      "Permet d'afficher les boutons de modification de fiche client (si le fitter le propose aussi)",
    key: 'can-do-request-appointment-modification-insurer',
  },
  {
    description:
      "Permet d'afficher les boutons d'annulation de fiche client (si le fitter le propose aussi)",
    key: 'can-do-request-appointment-cancel-insurer',
  },
  {
    description:
      "Permet d'afficher les boutons de modification de rdv annulé (si le fitter le propose aussi)",
    key: 'can-do-appointment-modification-after-cancel-insurer',
  },
  {
    description:
      "Permet d'afficher la vérification des coordonnées utilisateurs avant la validation de rdv",
    key: 'b2c-field-required-customer-data',
  },
  {
    description:
      "Permet de remplacer le contenu de la page 'customer-declaration' par un texte d'information (dico : CustomerInformationsPage.infoTitle / infoDescription)",
    key: 'b2c-display-customer-information-page-description',
  },
  {
    description:
      "Permet d'afficher le numéro du dossier sur la page de résumé et dans les mails",
    key: 'customer-mail-display-dossier-number',
  },
  {
    description:
      "Permet d'afficher le numéro du dossier dans la page de recherche et dans les mails",
    key: 'agenda-display-dossier-number-info',
  },
  {
    description:
      "Permet d'afficher le bouton de non validation des infos de pré-déclaration ('Back' pour modif)",
    key: 'b2c-display-pre-declaration-back-link',
  },
  {
    description: "Donne l'accès à la page d'administration",
    key: 'access-administration',
  },
  {
    description:
      "Permet d'afficher la question de préférence de contact (SMS, Email) à la fin du parcours B2C",
    key: 'b2c-can-declare-notification-type',
  },
  {
    description:
      "Permet d'afficher le 'product tour' d'aide en parcours B2B (lancé par défaut dès la première page)",
    key: 'b2b-display-product-tour',
  },
  {
    description:
      "Affichage d'un texte informatif supplémentaire au-dessus du carfrog, pour les pages de qualification de sinistre en B2C (Desktop only)",
    key: 'b2c-display-glasschoice-main-info',
  },
  {
    description:
      'Affiche un footer sur toutes les pages du parcours B2C (pas sur le parcours B2B)',
    key: 'b2c-display-footer',
  },
  {
    description:
      'Gère des illustrations avec des images au lieu de SVG pour le mobile',
    key: 'show-mobile-custom-illustration-image',
  },
  {
    description:
      "Ajoute l'onglet 'Gestionnaire' sur l'export Excel des dossiers",
    key: 'b2b-can-export-management-statistics',
  },
  {
    description:
      "Permet de rentrer dans le parcours en mode 'Open Arrival' avec la saisie de tous les champs dès la première page",
    key: 'b2c-use-open-arrival-complete-form',
  },
  {
    description:
      "Permet d'utiliser ReCaptcha dans l'entrée de parcours 'Open Arrival'",
    key: 'b2c-use-open-arrival-captcha',
  },
  {
    description: "Permet d'afficher les informations relatives aux paiements",
    key: 'b2c-display-sinister-payment-info-by-operation-type',
  },
  {
    description:
      'Prend en compte au niveau assureur la notion de pose à domicile',
    key: 'insurer-can-declare-in-mobility',
  },
  {
    description:
      'Prend en compte au niveau assureur la notion de véhicule de prêt',
    key: 'can-declare-replacement-vehicle-insurer',
  },
  {
    description: 'Permet de renseigner à qui appartient le véhicule du dossier',
    key: 'b2c-can-declare-car-ownership',
  },
  {
    description:
      "Affiche la question 'Êtes-vous assuré bris de glace' sur la dernière page de confirmation (avec possibilité de saisir l'assurance si 'Oui')",
    key: 'b2c-can-declare-insurance',
  },
  {
    description:
      'Permet de saisir la date de sinistre si non connue en arrivant sur la fenêtre de récap (cas POP3P)',
    key: 'b2c-declaration-start-step-sinister-date',
  },
  {
    description:
      'Permet de rendre facultative la date de sinistre lorsqu’elle est saisie au démarrage de la déclaration',
    key: 'b2c-declaration-start-step-sinister-date-not-required',
  },
  {
    description:
      "Permet d'ajouter un lien sur le logo pointant vers un site renseigné en conf et s'ouvrant dans la page courante",
    key: 'navbar-logo-link',
  },
  {
    description: "Affiche un bouton d'appel dans le header",
    key: 'b2c-can-make-call-navbar',
  },
  {
    description:
      "Affiche un bouton d'appel dans le header avec un comportement personnalisé",
    key: 'b2c-can-make-custom-call-navbar',
  },
  {
    description:
      "Affiche l'encadré 'Bonne nouvelle / Vous êtes assurés pour le bris de glace ...' pour certains vitrages (page glass choice)",
    key: 'b2c-display-glasschoice-insurance-info',
  },
  {
    description: "Affiche les informations d'adas",
    key: 'can-display-adas-alert',
  },
  {
    description:
      'Affichage inversée de la liste de filtres de recherche de slot',
    key: 'display-reverse-appointment-filter',
  },
  {
    description:
      "Affiche l'encadré 'Pour votre sécurité / Votre pare-brise doit être remplacé. ...' pour certains types d'impacts",
    key: 'b2c-display-impact-type-insurance-info',
  },
  {
    description:
      "Affiche l'encadré 'Pour votre sécurité / Votre pare-brise doit être remplacé. ...' pour certaines zones d'impacts",
    key: 'b2c-display-impact-fieldView-insurance-info',
  },
  {
    description:
      "Affiche l'encadré 'Vous êtes assurés pour le bris de glace ...'",
    key: 'b2c-display-lateral-glass-info',
  },
  {
    description: "Active l'envoi de messages par WhatsApp",
    key: 'send-customer-book-confirmation-with-whatsapp',
  },
  {
    description:
      'Permet de saisir un commentaire relatif à la qualification du sinistre en B2B (EN COURS DE DÉVELOPPEMENT)',
    key: 'b2b-can-declare-sinister-comment',
  },
  {
    description:
      'Permet de ne pas demander la date de sinistre en B2B (EN COURS DE DÉVELOPPEMENT)',
    key: 'b2b-field-required-sinister-date',
  },
  {
    description:
      "Permet d'afficher la date de sinistre en B2B sans la rendre obligatoire",
    key: 'b2b-field-optional-sinister-date',
  },
  {
    description:
      "Permet d'afficher le bouton de création d'un nouveau dossier dans la navbar du B2B",
    key: 'b2b-display-init-dossier-button',
  },
  {
    description: "Permet d'afficher les points d'intérêts sur la carte",
    key: 'b2b-display-points-of-interest',
  },
  {
    description:
      "Oblige la sélection d'un seul type de contact entre mail et téléphone",
    key: 'b2b-allow-only-one-contact-channel-phone-or-email',
  },
  {
    description:
      "Permet de rendre le prénom pas obligatoire lors de la création d'un dossier",
    key: 'b2b-allow-null-firstname',
  },
  {
    description:
      "Permet d'afficher les commentaires google d'un fitter sur sa page B2C",
    key: 'b2c-display-google-reviews',
  },
  {
    description:
      "Permet d'afficher les commentaires google d'un fitter sur sa page B2B",
    key: 'b2b-display-google-reviews',
  },
  {
    description:
      'Permet de sélectionner un montant de franchise lors de la déclaration du sinistre',
    key: 'b2b-can-declare-excess',
  },
  {
    description:
      'Permet de cacher le block de sélection de franchise en cas de réparation',
    key: 'b2b-hide-excess-if-reparation',
  },
  {
    description:
      "Permet d'afficher la franchise sur les pages accessibles aux fitters",
    key: 'b2b-display-excess-info-fitter',
  },
  {
    description: "Permet d'afficher la franchise sur les pages B2C",
    key: 'b2c-display-excess-info',
  },
  {
    description:
      "Permet d'afficher un indicateur visuel sur le fitter ayant le plus grand score lors de la recherche",
    key: 'b2b-highlight-best-scored-fitter',
  },
  {
    description:
      "Permet d'afficher les photos uploadé à la fin de la déclaration",
    key: 'display-end-declaration-pictures',
  },
  {
    description:
      "Permet de rendre read-only le champs 'Compagnie d'assurance' sur la page d'infos assuré B2B",
    key: 'b2b-read-only-insurer-company-name',
  },
  {
    description:
      'Permet de ne pas afficher le numéro sous forme de bouton mais de texte pour appeler le centre de pose dans les mails Customer book et rebook appointment',
    key: 'disallow-phone-call-for-customer-email',
  },
  {
    description:
      'Permet de ne pas afficher le numéro de téléphone du centre de pose dans les mails Customer book et rebook appointment',
    key: 'disallow-phone-show-for-customer-email',
  },
  {
    description:
      "Permet d'afficher le bloc des photos dans le mail customer même dans le cas où des photos ont été transmises dans le dossier (uniquement valable pour CUSTOMER-REBOOK-APPOINTMENT-CONFIRM pour l'instant)",
    key: 'display-shared-documents-for-customer-mail',
  },
  {
    description:
      'Permet de ne pas afficher le bouton Joindre les photos en parcours assureur',
    key: 'b2b-display-add-photo-button',
  },
  {
    description:
      "Permet d'effectuer des appels via le navigateur pour le fitter",
    key: 'b2b-allow-call-on-internet',
  },
  {
    description:
      "Permet d'effectuer des appels via le navigateur pour le client",
    key: 'b2c-allow-call-on-internet',
  },
  {
    description: "Permet d'envoyer le mail 'INSURER-CANCEL-APPOINTMENT'",
    key: 'send-insurer-cancel-appointment-email',
  },
  {
    description:
      "Agenda : Active l'envoi des mails / sms respectifs à l'assuré (post-réservation)",
    key: 'agenda-send-customer-link-after-book-or-cancel',
  },
  {
    description: "Rend obligatoire le choix de l'assurance en B2C",
    key: 'b2c-field-required-insurance-choice',
  },
  {
    description:
      "Permet d'afficher une checkbox pour saisir une assurance non listée en B2C",
    key: 'b2c-insurance-custom-name',
  },
  {
    description: 'Rend obligatoire le choix de la propriété du véhicule en B2C',
    key: 'b2c-field-required-ownership',
  },
  {
    description:
      "Permet d'effectuer le tracking de la connection des utilisateurs et d'afficher le graphique dans les stats en B2B",
    key: 'b2b-tracking-users-log',
  },
  {
    description:
      "Permet d'afficher de le numéro de téléphone GMB à la place du numéro de téléphone du fitter dans le résumé fixe du dossier",
    key: 'b2c-display-gmb-phone',
  },
  {
    description:
      "Permet d'afficher les smileys dans les interface de declaration de sinistre en B2C",
    key: 'b2c-display-sinister-declaration-smileys',
  },
  {
    description:
      "Permet d'envoyer un mail aux superviseurs d'un fitter quand il crée un event de type fermeture exceptionnelle",
    key: 'agenda-send-mail-on-exceptional-closing-creation',
  },
  {
    description:
      "Permet d'envoyer les notifications SMS/mail des rdv pris via agenda à 19h pour le lendemain",
    key: 'agenda-send-appointment-reminder',
  },
  {
    description:
      "Permet d'afficher le nom du centre sur la page de récapitulatif de RDV",
    key: 'b2b-display-brand-name-declaration-end',
  },
  {
    description:
      "Permet d'éviter la validation Joi des appels api concernant des dossiers",
    key: 'can-bypass-dossier-validation',
  },
  {
    description:
      'Oblige le customer à rebook un rdv chez le même fitter que précédement à partir du lien de cancel de son mail',
    key: 'b2c-rebook-only-same-fitter-from-mail',
  },
  {
    description:
      'Oblige le customer à modifier un rdv chez le même fitter que précédement à partir du lien de modification de son mail',
    key: 'b2c-modify-only-same-fitter-from-mail',
  },
  {
    description:
      "Permet d'afficher le tableau de provenance des rendez-vous pour les statistiques Fitter",
    key: 'fitter-dashboard-display-appointment-origins-bar-chart',
  },
  {
    description: "Permet d'importer les droits d'accès au B2B",
    key: 'can-import-b2b-access-list',
  },
  {
    description: "Permet d'importer les droits d'accès à l'agenda",
    key: 'can-import-agenda-access-list',
  },
  {
    description:
      "Permet de d'afficher une tooltip simplifiée au moment du hover d'un dossier dans le calendrier",
    key: 'agenda-simplify-dossier-tooltip',
  },
  {
    description:
      "Permet d'envoyer un mail lors de la réception d'une fiche client via l'API Agenda si elle ne vient pas de Aari",
    key: 'agenda-send-fitter-link-after-request',
  },
  {
    description:
      "Permet d'envoyer un mail/sms lors de l'annulation d'un RDV via l'API Agenda si elle ne vient pas de Aari",
    key: 'agenda-send-fitter-link-after-cancel',
  },
  {
    description: 'Permet de modifier les in',
    key: 'agenda-can-modify-default-intervention-type',
  },
  {
    description: 'Permet de masquer les dossiers abandonnés dans la recherche',
    key: 'agenda-hide-abandonned-files',
  },
  {
    description:
      "Permet d'activer la fonctionnalité d'abandon de dossier et de visualiser ces dossier dans la recheche / l'export excel",
    key: 'b2b-allow-abandon-files',
  },
  {
    description:
      'Permet de ne pas pas tenir compte des réparations pour la proposition de slots en centre',
    key: 'agenda-only-count-replace-for-center-slots',
  },
  {
    description:
      "Permet d'afficher les alertes liées aux fiches client même dans un contexte qui n'est pas la fiche client",
    key: 'force-display-request-appointment-alerts',
  },
  {
    description:
      "B2C: Permet d'afficher un avertissement si le client déclare ne pas avoir une assurance",
    key: 'b2c-display-no-insurance-warning',
  },
  {
    description: 'B2C entrée de parcours avec la plaque (auto-open-arrival)',
    key: 'b2c-auto-open-arrival',
  },
  {
    description:
      'Use specific car frog with 5 lateral glasses instead of the basic one',
    key: 'use-car-summary-5-lat',
  },
  {
    description:
      'Permet de rendre le champs email des formulaires B2C en readonly dans le cas où il aurait déjà été rempli précédement',
    key: 'b2c-disable-email-modif',
  },
  {
    description:
      "Permet d'accélérer le parcours en validant automatiquement la page quand un choix a été fait dans son formulaire",
    key: 'b2c-auto-submit-form',
  },
  {
    description:
      "Permet de consulter les données clients par appel d'api du contract-manager",
    key: 'integ-contract-manager-customer-data',
  },
  {
    description:
      'Permet de transmettre les rendez-vous à Next Conversion Campaign',
    key: 'send-next-conversion-campaign-contact',
  },
  {
    description:
      "Permet de notifier le contract manager par appel d'api sur les création, cancel, update de dossier",
    key: 'integ-contract-manager-push-dossier',
  },
  {
    description:
      'Permet de notifier le contract manager par passager de param sur les redirect_uri sur les création, cancel, update de dossier',
    key: 'integ-contract-manager-redirect-dossier-by-param',
  },
  {
    description:
      'Permet de supprimer les dossiers B2C en doubles qui ne sont pas complet en fin de journée',
    key: 'b2c-remove-uncompleted-duplicates',
  },
  {
    description:
      'Permet de supprimer les dossiers B2B en doubles qui ne sont pas complet en fin de journée',
    key: 'b2b-remove-uncompleted-duplicates',
  },
  {
    description:
      "Permet d'accèder aux différentes étapes de la déclaration selon l'avancement du dossier",
    key: 'b2b-acces-declaration-steps-by-dossier',
  },
  {
    description:
      "Permet d'afficher une checkbox sur les inputs de numéro de téléphone pour désactiver la vérification de pattern",
    key: 'can-bypass-phone-validation-with-checkbox',
  },
  {
    description: 'Use expansion pannel for password login on B2B login',
    key: 'b2b-password-login-on-expansion-panel',
  },
  {
    description:
      'Sur le B2B, Permet de ne pas recréer un dossier si un est déjà en cours dans la même journée (reprend celui existant)',
    key: 'b2b-avoid-duplicate-create-dossier',
  },
  {
    description:
      'Sur le B2C, Permet de ne pas recréer un dossier si un est déjà en cours dans la même journée (reprend celui existant)',
    key: 'b2c-avoid-duplicate-create-dossier',
  },
  {
    description: 'Liens de redirection en B2C: rester sur le même onglet',
    key: 'b2c-exit-link-self-target',
  },
  {
    description:
      "Permet de récupérer les instance où l'utilisateur ferme l'onglet AARI B2B",
    key: 'b2b-register-app-close',
  },
  {
    description:
      "Permet de récupérer les instance où l'utilisateur ferme l'onglet AARI B2C",
    key: 'b2c-register-app-close',
  },
  {
    description:
      'On the search-page, by default, sort the results by the nearest appointments (instead of the earliest)',
    key: 'search-page-default-sort-by-nearest',
  },
  {
    description:
      'Permet de rediriger vers une URL prédéfinie au lieu de naviguer vers la page de résumé après avoir validé un créneau en B2B',
    key: 'b2b-redirect-after-slot-select',
  },
  {
    description:
      'Permet de rediriger vers une URL prédéfinie au lieu de naviguer vers la page de résumé après avoir validé un créneau en B2C',
    key: 'b2c-redirect-after-slot-select',
  },
  {
    description:
      "Afficher les infomations du véhicule avec l'année de première enregistrement",
    key: 'display-vehicle-information-year',
  },
  {
    description:
      "Compléte le dommage si le vitrage 'windshield' est identifié mais pas qualifié lors du createDossier",
    key: 'use-default-damage-qualif-for-windshield',
  },
  {
    description: "Permet à l'assureur de renvoyer un mail de notification",
    key: 'b2b-can-resend-customer-notification',
  },
  {
    description: "Permet d'afficher les icons des questions de sinistre en B2B",
    key: 'b2b-display-sinister-icons',
  },
  {
    description:
      "Permet d'afficher certains inputs d'infos customer au moment de la sélection d'un créneau pour le B2B",
    key: 'b2b-display-customer-info-confirmation-on-validation',
  },
  {
    description:
      "Permet d'afficher le logo du partenaire fitter à la place de l'icône de prise de rendez-vous dans la modale de sélection de créneau",
    key: 'b2c-display-fitter-logo-on-appointment-selection-sheet',
  },
  {
    description:
      "Permet d'afficher les fitters mobiles en priorité dans la recherche de créneaux",
    key: 'mobile-service-after-center',
  },
  {
    description:
      "Permet d'afficher les fitters mobiles avant les centres dans la recherche de créneaux",
    key: 'mobile-service-before-center',
  },
  {
    description:
      "Permet d'afficher les conditions de couverture assurancielles pour n'importe quel vitrage, pas uniquement windshield/lateral/rear",
    key: 'display-insurance-cover-for-all-glass',
  },
  {
    description:
      "Permet au fitter d'utiliser la fonctionnalité d'appel de twilio",
    key: 'b2b-fitter-can-call-twillio',
  },
  {
    description: "Permet aux fitters de l'agenda de s'y connecter via OIDC",
    key: 'agenda-auth-method-oidc',
  },
  {
    description:
      'Empêche de remplir certaines informations dans le formulaire de B2B',
    key: 'b2b-non-editable-form',
  },
  {
    description:
      "Permet l'affichage de la fonctionnalité 'Adresse de facturation différente' côté Agenda",
    key: 'agenda-diff-billing-address',
  },
  {
    description:
      "Permet l'ajout d'un toggle pour pouvoir afficher en pourcentage ou non dans la partie 'Statistiques'",
    key: 'b2b-toggle-percentage',
  },
  {
    description:
      'Permet de faire apparaitre une checkbox pour appliquer ou non le format de plaque du pays',
    key: 'checkbox-enable-plate-format',
  },
  {
    description:
      "Permet de systématiquement considérer l'assuré comme garanti, tant qu'il a un dossier d'assurance et qu'il n'a pas sélectionné de vitrage en B2C",
    key: 'b2c-default-display-insured-without-glass',
  },
  {
    description:
      "Permet de systématiquement considérer l'assuré comme garanti, tant qu'il a un dossier d'assurance et qu'il n'a pas sélectionné de vitrage en B2B",
    key: 'b2b-default-display-insured-without-glass',
  },
  {
    description:
      "Permet de d'empècher la recherche de créneaux en B2C dans le cas où l'utilisateur n'est pas assuré bris de glace (pour les conditions de base, sans tenir compte du vitrage / de la franchise)",
    key: 'b2c-disable-booking-without-insurance',
  },
  {
    description:
      "Permet de d'empècher la recherche de créneaux en B2B dans le cas où l'utilisateur n'est pas assuré bris de glace (pour les conditions de base, sans tenir compte du vitrage / de la franchise)",
    key: 'b2b-disable-booking-without-insurance',
  },
  {
    description: 'Permet de démarrer une nouvelle déclaration en b2c',
    key: 'b2c-can-restart-declaration',
  },
  {
    description: 'Permet da faire un book sans passer par la dernière page',
    key: 'b2c-allow-book-on-search-step',
  },
  {
    description: 'Permet da faire un request sans passer par la dernière page',
    key: 'b2c-allow-request-on-search-step',
  },
  {
    description:
      "Permet d'afficher la vue calandrier dans la page de recherche",
    key: 'b2b-can-display-calendar',
  },
  {
    description:
      'Active la fonctionnalité de synchronization avec le systeme Horizons',
    key: 'enable-horizons-sync',
  },
  {
    description:
      "Utilise le partnerId des appointments comme l'Id des FS coté Horizon et non comme le codeFS (par défaut)",
    key: 'enable-horizons-sync-with-Id',
  },
  {
    description:
      'Remonter le nombre de fitters dans les statistique de super-admin',
    key: 'super-admin-statistics-allow-fitter-count',
  },
  {
    description:
      'Permet de compter les dossiers dupliqués de B2C vers B2B avec les statistiques de taux de transformation',
    key: 'stats-count-duplicates-from-b2c-to-b2b',
  },
  {
    description:
      'Permet de compter les dossiers dupliqués de B2B vers B2C avec les statistiques de taux de transformation',
    key: 'stats-count-duplicates-from-b2b-to-b2c',
  },
  {
    description: "Permet d'afficher les RDVs PAD en premier",
    key: 'expand-mobility-first',
  },
  {
    description: "Permet de cacher l'identification par mot de passe en B2B",
    key: 'b2b-hide-auth-method-password',
  },
  {
    description:
      "Permet de valider une adresse dans les formulaires de l'agenda, même si toutes les infos ne sont pas dispos",
    key: 'agenda-mobility-force-complete-address',
  },
  {
    description:
      "Permet de poursuivre sur le B2B un dossier qui a été initié sur le B2C (téléconseiller reprend le dossier d'un sociétaire)",
    key: 'b2b-continue-b2c-dossier',
  },
  {
    description:
      "Permet de poursuivre sur le B2C un dossier qui a été initié sur le B2B (sociétaire reprend le dossier d'un téléconseiller)",
    key: 'b2c-continue-b2b-dossier',
  },
  {
    description: 'Rend les numéros de téléphone cliquables sur mobile',
    key: 'b2c-phone-number-click-to-call-in-mobile',
  },
  {
    description:
      'get the insurance suggestion directly from partner ICList service instead of the hardcoded list from configuration',
    key: 'insurance-suggestion-from-iclist',
  },
  {
    description:
      "Déverrouilles les champs code postal et ville lorsque l'adresse n'est pas trouvée",
    key: 'unlock-city-when-address-not-found',
  },
  {
    description:
      "Trace les données de l'agent B2B dans le csv et l'export excel avec le premier agent ayant touché le dossier et non le créateur initial",
    key: 'b2b-populate-agents-info-from-first-editor',
  },
  {
    description: 'Ask user to confirm the appointment canceling reason',
    key: 'appointment-canceling-reason',
  },
  {
    description: 'Show cancellation reason in cancellation email',
    key: 'show-cancellation-reason-in-email',
  },
  {
    description: 'Enable NPS survey at the end of B2C journey',
    key: 'nps-survey-customer',
  },
  {
    description: 'Enable NPS survey at the end of B2B journey',
    key: 'nps-survey-fitter',
  },
  {
    description: "L'usage de tag commander pour le buffering des events",
    key: 'tag-commander-global-buffer',
  },
  {
    description:
      "L'usage de tag commander pour le push des events utilisé après le chargement de SDK TC",
    key: 'tag-commander-sdk-tc',
  },
  {
    description:
      "Le dossier créé via l'API ne peut pas être modifié via le B2B",
    key: 'b2b-disallow-api-creation-dossier-edit',
  },
  {
    description:
      "Le dossier créé via l'API ne peut pas être modifié via le B2C",
    key: 'b2c-disallow-api-creation-dossier-edit',
  },
  {
    description:
      "L'accès au dossier, créé via l'API, se basera sur les informations de callAgent",
    key: 'insurer-create-callagent-account',
  },
  {
    description:
      'Enables Google Reserve with Google button conversion tracking on appointment booking',
    key: 'b2c-google-reserve-with-google-tracking',
  },
  {
    description:
      'Permet de récupérer le numéro client plus tôt dans le parcours B2C',
    key: 'b2c-get-customer-number-earlier',
  },
  {
    description: 'Hide the map in the fitter page',
    key: 'hide-fitter-map',
  },
  {
    description:
      "Permet d'afficher en permanence l'icône fitter sur les dots de la carte, sans attendre le hover",
    key: 'map-dot-fitters-always-display-fitter-icon',
  },
  {
    description: "Peut déclarer le numéro VIN dans l'agenda",
    key: 'agenda-can-declare-vin-number',
  },
  {
    description:
      "Permet de décocher par défaut l'option 'A domicile' sur la page de recherche",
    key: 'search-page-default-uncheck-outsideIntervention',
  },
  {
    description:
      'Empêche la désélection automatique du fitter à la destruction de la page fitter',
    key: 'preserve-selected-fitter-on-destroy',
  },
  {
    description: "Permet d'envoyer événements à l'iframe parent",
    key: 'b2c-send-events-to-parent-iframe',
  },
  {
    description: "Permet d'afficher un bouton de retour en dessous de la carte",
    key: 'display-undermap-return-btn',
  },
  {
    description:
      "Permet d'afficher un bouton centre non trouvé en dessous de la carte",
    key: 'display-undermap-noslot-fits-btn',
  },
  {
    description:
      "Permet d'afficher un bouton centre non trouvé en dessous de la carte",
    key: 'display-undermap-noslot-fits-btn-with-condition',
  },
  {
    description: 'Permet de gérer le numéro RRI',
    key: 'can-manage-rri-number',
  },
  {
    description:
      'Permet de faire quitter le parcours B2C après la réservation d’un rendez-vous',
    key: 'b2c-redirect-after-booking',
  },
  {
    description:
      "Permet d'afficher la dernière page de B2C avec un loader et un texte de redirection",
    key: 'b2c-allow-loader-summary-page',
  },
  {
    description:
      'Affiche la plage de durée ADAS (entre X et Y) pour le remplacement de pare-brise avec calibration ADAS',
    key: 'display-adas-duration-range',
  },
];
